export default {
  button: {
    display: 'inline-block',
    border: 'none',
    fontWeight: 'bold',
    textAlign: 'center',
    textDecoration: 'none',
    WebkitTextSizeAdjust: 'none',
    marginTop: '10px',
    paddingLeft: '20px',
    paddingRight: '20px',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}
